import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7301fe2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "gpt-question-control"
}
const _hoisted_2 = { class: "questions-panel" }
const _hoisted_3 = { class: "questions-status" }
const _hoisted_4 = { class: "retention-label" }
const _hoisted_5 = { class: "submission-error" }
const _hoisted_6 = ["aria-busy"]
const _hoisted_7 = { class: "turn-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我：", -1))
const _hoisted_9 = { class: "question-text" }
const _hoisted_10 = { class: "answer-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "蓝迪云AI：", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "answer-text"
}
const _hoisted_14 = {
  key: 1,
  class: "answer-status"
}
const _hoisted_15 = {
  key: 2,
  class: "answer-status"
}
const _hoisted_16 = {
  key: 3,
  class: "failed-answer"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复失败", -1))
const _hoisted_18 = { class: "question-composer" }
const _hoisted_19 = { class: "composer-actions" }
const _hoisted_20 = {
  key: 0,
  class: "answer-status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_SendOutlined = _resolveComponent("SendOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.allowed)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", { openPanel: _ctx.openPanel }, undefined, true),
        _createVNode(_component_a_modal, {
          visible: _ctx.visible,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
          title: "蓝迪云AI-智能助手",
          footer: null,
          width: 760,
          style: _normalizeStyle({ maxWidth: 'calc(100vw - 24px)', top: '24px' }),
          "destroy-on-close": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_tag, {
                  color: _ctx.online ? 'green' : 'default'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.online ? '在线' : '离线'), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                _createElementVNode("span", _hoisted_4, "保留最近" + _toDisplayString(_ctx.retentionDays) + "天记录", 1),
                _createVNode(_component_a_button, {
                  type: "text",
                  size: "small",
                  title: "刷新",
                  "aria-label": "刷新",
                  loading: _ctx.loading,
                  disabled: _ctx.sending,
                  onClick: _ctx.refreshQuestions
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_ReloadOutlined)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              (_ctx.loadError)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    class: "question-alert",
                    type: "error",
                    message: _ctx.loadError,
                    "show-icon": ""
                  }, null, 8, ["message"]))
                : (_ctx.loaded && !_ctx.online)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 1,
                      class: "question-alert",
                      type: "warning",
                      message: "蓝迪云AI当前离线，问题将等待回复",
                      "show-icon": ""
                    }))
                  : _createCommentVNode("", true),
              (_ctx.submitError)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 2,
                    class: "question-alert",
                    type: "error",
                    "show-icon": ""
                  }, {
                    message: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.submitError), 1),
                        (_ctx.retryAttempt)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              size: "small",
                              title: "重试提交",
                              disabled: !_ctx.canRetry,
                              onClick: _ctx.retrySubmission
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_ReloadOutlined)
                              ]),
                              default: _withCtx(() => [
                                _createTextVNode("重试")
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                ref: "conversation",
                class: "question-history",
                "aria-live": "polite",
                "aria-busy": _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_a_spin, {
                      key: 0,
                      class: "history-loading"
                    }))
                  : (!_ctx.messages.length && _ctx.loaded)
                    ? (_openBlock(), _createBlock(_component_a_empty, {
                        key: 1,
                        description: "暂无提问"
                      }))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (question) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: question.id,
                    class: "question-turn"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("time", null, _toDisplayString(_ctx.formatMessageTime(question.createdAt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(question.text), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      (question.answer)
                        ? (_openBlock(), _createElementBlock("time", _hoisted_12, _toDisplayString(_ctx.formatMessageTime(question.updatedAt)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (question.answer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(question.answer), 1))
                      : _createCommentVNode("", true),
                    (question.status === 'pending')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "等待回复"))
                      : (question.status === 'answering')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_LoadingOutlined),
                            _createTextVNode("正在回答")
                          ]))
                        : (question.status === 'failed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _hoisted_17,
                              _createVNode(_component_a_button, {
                                size: "small",
                                title: "重新提问",
                                disabled: !_ctx.canRetry,
                                onClick: ($event: any) => (_ctx.retryQuestion(question))
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_ReloadOutlined)
                                ]),
                                default: _withCtx(() => [
                                  _createTextVNode("重试")
                                ]),
                                _: 2
                              }, 1032, ["disabled", "onClick"])
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_a_textarea, {
                  value: _ctx.draft,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
                  maxlength: 4000,
                  rows: 3,
                  disabled: _ctx.sending,
                  placeholder: "可以这样向我提问：某某功能的详细使用说明",
                  "aria-label": "问题",
                  "show-count": ""
                }, null, 8, ["value", "disabled"]),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.hasActiveQuestion)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.activeStatus === 'answering' ? '正在回答' : '等待回复'), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    title: "发送问题",
                    loading: _ctx.sending,
                    disabled: !_ctx.canSubmit,
                    onClick: _ctx.submitQuestion
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_SendOutlined)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("发送")
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible", "style"])
      ]))
    : _createCommentVNode("", true)
}